import { useUser } from '@/src/store/user.context';
import { Input, SpaceBetween, TimeInput, TimeInputProps } from '@amzn/awsui-components-react';

export const CustomTimeInput: React.FC<TimeInputProps> = (props) => {
  const { user } = useUser();

  return (
    <SpaceBetween direction="vertical" size="xxxs">
      {user?.isSuperAdmin ? <Input {...props} /> : <TimeInput {...props} />}
    </SpaceBetween>
  );
};
